@if (visible) {
<div class="fullscreen-spinner-overlay">
	<img src="assets/images/biorugged.png" width="100px" />
	<!-- <div class="spinner-border text-primary" role="status" style="width: 5rem; height: 5rem;"></div> -->
	<!-- <div class="pulse-loader"></div> -->
	<!-- <div class="bounce-loader">
		<div></div>
		<div></div>
		<div></div>
	</div> -->
	<div class="dots-loader mt-3">
		<div></div>
		<div></div>
		<div></div>
	</div>
	<p class="message text-primary mt-2">{{message}}</p>
</div>
}